import { Badge, Box, Flex } from '@chakra-ui/react';
import moment from 'moment';
import { getStatusLabel } from 'shared/helpers/orderStatus';
import { Order, orderStatus } from 'shared/models/order';
import { BadgeThemeKeys } from 'theme/components/Badge';

interface BadgeRenderData {
  variant: BadgeThemeKeys;
  dotColor?: string;
  statusId: orderStatus;
  label?: string;
}
interface OrderStatusBadgeProps {
  order: Order;
  loading: boolean;
}
const OrderStatusBadge = ({ order, loading }: OrderStatusBadgeProps) => {
  const badgeVariantMap: BadgeRenderData[] = [
    {
      variant: BadgeThemeKeys.YOOGA_PRIMARY,
      dotColor: 'yPrimary.800',
      statusId: orderStatus.ACORDO,
    },
    {
      variant: BadgeThemeKeys.YOOGA_RED,
      dotColor: 'yRed.800',
      statusId: orderStatus.CANCELADO,
    },
    {
      variant: BadgeThemeKeys.YOOGA_YELLOW,
      dotColor: 'yYellow.800',
      statusId: orderStatus.EM_ABERTO,
    },
    {
      variant: BadgeThemeKeys.YOOGA_GREEN,
      dotColor: 'yGreen.800',
      statusId: orderStatus.PAGO,
    },
  ];

  const isOverdue = (order: Order): boolean => {
    return (
      order.statusId === orderStatus.EM_ABERTO &&
      !!order.due_date &&
      order.due_date.isBefore(moment(), 'day')
    );
  };

  const getBadgeVariant = (order: Order): BadgeRenderData => {
    if (isOverdue(order)) {
      return {
        variant: BadgeThemeKeys.YOOGA_ORANGE,
        dotColor: 'yOrange.800',
        statusId: orderStatus.EM_ABERTO,
        label: 'Vencido',
      };
    }

    let badgeVariant = badgeVariantMap[0];
    badgeVariantMap.forEach((variant) => {
      if (variant.statusId === order.statusId) {
        badgeVariant = variant;
      }
    });
    return badgeVariant;
  };
  const variant = getBadgeVariant(order);
  return (
    <Badge
      variant={loading ? 'loading' : String(variant.variant)}
      h={loading ? '32.5px' : ''}
      w={loading ? '80px' : ''}
    >
      <Flex gap="2" align="center">
        {!loading && (
          <Box w="10px" h="10px" borderRadius="100px" bg={variant.dotColor} />
        )}
        {variant.label || getStatusLabel(variant.statusId as orderStatus)}
      </Flex>
    </Badge>
  );
};
export default OrderStatusBadge;
